export default "__VITE_ASSET__WI5kmYIg__"